module.exports = __webpack_public_path__ + "img/loading.67ac2bf7.gif";